import { Col } from "react-bootstrap";
import Jobs from "./Jobs";
import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import ProfileConfig from "@serie3/freelancesplaceapi/Config/Profiles/ProfileConfig";
import ProfilePicture from "./ProfilePicture";
import NewModal from "../documents/modals/NewModal";
import FileDropzone from "../documents/modals/FileDropzone";
import { useState } from "react";
import PDFModal from "../../../layout/Popups/PDFModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCamera } from "@fortawesome/free-solid-svg-icons";

const ProfileLeft = ({ formik, profile, updateJobs }) => {
  const [showProfileUpload, setShowProfileUpload] = useState(false);
  const [triggerRerenderProfile, setTriggerRerenderProfile] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const downloadUrl = ProfileConfig.endpoints.download + profile.id;
  const uploadUrl = ProfileConfig.endpoints.edit;

  const vorname = formik.getFieldProps("vorname").value || "";
  const name = formik.getFieldProps("name").value || "";
  const profiletitle = formik.getFieldProps("profiletitle").value || "";
  const fullName = [vorname, name].filter(Boolean).join(" ") || "Your Profile";

  return (
    <>
      <PDFModal showSpinner={showSpinner} setShowSpinner={setShowSpinner} />
      <NewModal show={showProfileUpload} setShow={setShowProfileUpload}>
        <FileDropzone
          uploadUrl={uploadUrl}
          additionalData={{ id: profile.id }}
          edit={true}
          setName={false}
          setData={() => setTriggerRerenderProfile(Math.random())}
        />
      </NewModal>

      <Col className="col-md-3">
        {/* Profile card */}
        <div style={{
          background: "#fff", borderRadius: "16px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}>
          {/* Banner */}
          <div style={{
            height: "72px",
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
          }} />

          <div style={{ padding: "0 20px 24px" }}>
            {/* Avatar with upload overlay */}
            <div
              onClick={() => setShowProfileUpload(true)}
              style={{
                position: "relative", width: "72px", height: "72px",
                marginTop: "-36px", marginBottom: "14px",
                cursor: "pointer",
              }}
            >
              <div style={{
                width: "72px", height: "72px", borderRadius: "50%",
                border: "3px solid #fff",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}>
                <ProfilePicture
                  profileId={profile.id}
                  pictureSize="66px"
                  rerender={triggerRerenderProfile}
                />
              </div>
              {/* Hover overlay */}
              <div style={{
                position: "absolute", inset: 0, borderRadius: "50%",
                background: "rgba(0,0,0,0.45)",
                display: "flex", alignItems: "center", justifyContent: "center",
                opacity: 0, transition: "opacity 0.15s",
                color: "#fff", fontSize: "0.9rem",
              }}
                onMouseEnter={e => e.currentTarget.style.opacity = 1}
                onMouseLeave={e => e.currentTarget.style.opacity = 0}
              >
                <FontAwesomeIcon icon={faCamera} />
              </div>
            </div>

            <div style={{ fontWeight: 800, fontSize: "1.05rem", color: "#212121", marginBottom: "2px" }}>
              {fullName}
            </div>
            {profiletitle && (
              <div style={{
                display: "inline-block", fontSize: "0.72rem", fontWeight: 700,
                padding: "2px 10px", borderRadius: "99px",
                background: "#e8f0fe", color: "#1a73e8", marginBottom: "18px",
              }}>
                {profiletitle}
              </div>
            )}

            {!profile.system_profile && (
              <button
                type="button"
                onClick={() => {
                  setShowSpinner(true);
                  downloadHandler(downloadUrl, profile.title + ".pdf", null, setShowSpinner);
                }}
                style={{
                  width: "100%", padding: "9px", border: "none",
                  borderRadius: "10px", fontWeight: 700, fontSize: "0.85rem",
                  background: "#e8f0fe", color: "#1a73e8", cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "7px",
                  transition: "background 0.15s",
                }}
                onMouseOver={e => e.currentTarget.style.background = "#d2e3fc"}
                onMouseOut={e => e.currentTarget.style.background = "#e8f0fe"}
              >
                <FontAwesomeIcon icon={faDownload} style={{ fontSize: "0.78rem" }} />
                Download CV
              </button>
            )}
          </div>
        </div>

        {!profile.system_profile && (
          <Jobs updateJobs={updateJobs} profileId={profile.id} />
        )}
      </Col>
    </>
  );
};

export default ProfileLeft;
